export const KNOWLEDGE_BASE_URL =
  'https://knowledge-base.yieldbird.com/yieldbird-platform/media-types' as const
